import {FC} from 'react';
import {
	DocumentPhotoScreenConfig,
	DocumentPhotoSlotValue,
	ForeignDocumentType,
	ForeignDocumentTypeOption,
} from '../../model';
import {DocumentTypeSelect} from '../components/DocumentTypeSelect/DocumentTypeSelect';
import {PassportPhotoUpload} from '../components/PassportPhotoUpload/PassportPhotoUpload';
import {StepLayout} from 'features/registration';
import styles from './DocumentPhotosStep.module.css';

type Props = {
	config: DocumentPhotoScreenConfig;
	values: Record<string, DocumentPhotoSlotValue>;
	onSelect: (slotId: string, file: File) => void;
	onRemove: (slotId: string) => void;
	title?: string;
	documentTypeOptions?: ForeignDocumentTypeOption[];
	documentType?: ForeignDocumentType;
	onDocumentTypeChange?: (value: ForeignDocumentType) => void;
};

export const DocumentPhotosStep: FC<Props> = ({
	config,
	values,
	onSelect,
	onRemove,
	title,
	documentTypeOptions,
	documentType,
	onDocumentTypeChange,
}) => {
	return (
		<StepLayout>
			<StepLayout.Title>{title ?? config.title}</StepLayout.Title>

			<StepLayout.Content className={styles.sections}>
				{documentTypeOptions && documentType && onDocumentTypeChange ? (
					<DocumentTypeSelect
						value={documentType}
						options={documentTypeOptions}
						onChange={onDocumentTypeChange}
					/>
				) : null}

				{config.slots.map((slot) => (
					<PassportPhotoUpload
						key={slot.id}
						label={slot.label}
						previewUrl={values[slot.id]?.previewUrl ?? null}
						onSelect={(file) => onSelect(slot.id, file)}
						onRemove={() => onRemove(slot.id)}
					/>
				))}
			</StepLayout.Content>
		</StepLayout>
	);
};
